import EditIcon from "@mui/icons-material/Edit";
import parse from "html-react-parser";
import { Accordion, Container, Row, Col, Button } from "react-bootstrap";

import HTMLEditor from "components/UI/HTMLEditor";

const InitialComments = ({
  review,
  userCanEdit,
  setIsEditing,
  isEditing,
  handleChange,
  handleChangeTextField,
  textFieldUpdate,
}) => {
  return (
    <Accordion className="my-4" flush defaultActiveKey="0">
      <Accordion.Item eventKey="0">
        <Accordion.Header>
          <h6 className="fw-bold text-dark">INITIAL COMMENTS</h6>
        </Accordion.Header>
        <Accordion.Body>
          <Container>
            <Row>
              {isEditing === "blurba" ? (
                <Col>
                  <HTMLEditor
                    name="blurba"
                    handleChange={handleChangeTextField}
                    setIsValid={() => {}}
                    isValid={true}
                    defaultValue={review?.blurba}
                  />
                </Col>
              ) : (
                <Col>{review?.blurba && parse(review?.blurba)}</Col>
              )}
              <Col sm={1}>
                {userCanEdit &&
                  (isEditing === "blurba" ? (
                    <>
                      <Button
                        variant="primary"
                        onClick={() =>
                          handleChange({
                            target: {
                              name: "blurba",
                              value: textFieldUpdate.blurba,
                            },
                          })
                        }
                      >
                        Save
                      </Button>
                      <Button
                        variant="warning"
                        className="mt-2"
                        onClick={() => setIsEditing("")}
                      >
                        Cancel
                      </Button>
                    </>
                  ) : (
                    <div className="d-flex justify-content-end">
                      <EditIcon
                        className="edit-button clickable"
                        onClick={() => {
                          setIsEditing("blurba");
                        }}
                        data-testid="edit-blurba"
                      />
                    </div>
                  ))}
              </Col>
            </Row>
          </Container>
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
  );
};

export default InitialComments;
